export default {"src":"/_next/static/media/left-arrow.f766ce93.svg","height":20,"width":21};